import { useStore } from "@/store";
import { ProfileType, ProfileDetail } from "@/types";
import { flashWarning } from "@/utils";

type Profile = ProfileType | ProfileDetail;

const hasRollObject = (profile: Profile): profile is ProfileDetail => {
    return typeof profile.roll === "object" && profile.roll !== null;
};

export const convertProfileData = ({
    profile,
    showRoll,
    showOrgUnit,
}: {
    profile: Profile;
    showRoll?: boolean;
    showOrgUnit?: boolean;
}) => {
    let label = profile.user_display.name;

    // TODO: Formatera bättre ("Namn - Roll, Enhet" / "Namn - Roll" / "Namn - Enhet")
    if (showRoll && profile.roll_display) {
        label += ` - ${profile.roll_display.displayName}`;
    }
    if (showOrgUnit) {
        label += `, ${profile.orgUnit_display.name}`;
    }

    return {
        value: profile.id,
        label,
    };
};

export const fetchProfilesRollAndOrgUnit = async ({
    params,
    showRoll,
    showOrgUnit,
}: {
    params: { [key: string]: unknown };
    showRoll: string;
    showOrgUnit: string;
}) => {
    const store = useStore();

    try {
        const { subsetName } = await store.dispatch("profile/fetchProfiles", {
            filterParams: params,
            displayMode: false,
        });

        const subset = store.getters["profile/profileSubset"]({ subsetName });

        let showRollBoolean = false;
        let showOrgUnitBoolean = false;

        if (showRoll === "if-multiple") {
            // Visa roll om inte alla profiler har samma roll
            showRollBoolean = !subset.every(
                (profile: Profile) => hasRollObject(profile) && profile.roll.id === subset[0].roll.id
            );
        } else {
            showRollBoolean = showRoll === "yes";
        }

        if (showOrgUnit === "if-multiple") {
            // Visa enhet om inte alla profiler har samma enhet
            showOrgUnitBoolean = !subset.every((profile: Profile) => profile.orgUnit.id === subset[0].orgUnit.id);
        } else {
            showOrgUnitBoolean = showOrgUnit === "yes";
        }

        return subset.map((profile: Profile) =>
            convertProfileData({ profile, showRoll: showRollBoolean, showOrgUnit: showOrgUnitBoolean })
        );
    } catch (error) {
        flashWarning("Kunde inte hämta profiler.");
    }
};
